<template>
    <v-dialog
            v-model="dialog"
            width="500"
    >
        <v-card>
            <v-card-title
                    class="headline grey lighten-2"
                    primary-title
            >
                {{ $t('build.feedback.title') }}
            </v-card-title>

            <v-card-text>
                {{ feedback }}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        flat
                        @click="closeDialog"
                >
                    {{ $t('build.feedback.ok') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: "BuildFeedbackDialog",
        props: {
            dialog: {
                type: Boolean
            }
        },
        computed: {
            ...mapGetters({
                firebaseProject: "projects/firebaseProject",
                androidApp: "projects/androidApp",
                iosApp: "projects/iosApp",
                sha: "projects/sha",
            }),
            feedback() {
                if (this.hasError()) {
                    return this.$t('build.feedback.hasError')
                }
                return this.$t('build.feedback.success')
            }
        },
        methods: {
            closeDialog() {
                this.$emit('close');
            },
            hasError() {
                return (this.firebaseProject && this.firebaseProject.buildStatus === 'error')
                || (this.androidApp && this.androidApp.buildStatus === 'error')
                || (this.iosApp && this.iosApp.buildStatus === 'error')
                || (this.sha && this.sha.buildStatus === 'error')
            }
        }
    }
</script>

<style scoped>

</style>
